import { render, staticRenderFns } from "./ProductCoproducers.vue?vue&type=template&id=087643ea&"
import script from "./ProductCoproducers.vue?vue&type=script&lang=js&"
export * from "./ProductCoproducers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports